import { TableCell, TableRow } from "@mui/material";
import { format } from "date-fns";
import React from "react";

import { IExecutionLog } from "@/interfaces/execution-log.interfaces";

interface Props {
  log: IExecutionLog;
  index: number;
}

export function ExecutionLogRow({ log, index }: Props) {
  const formattedDate = format(new Date(log.dateSent), "dd/MM/yyyy HH:mm:ss");

  return (
    <TableRow key={`${index} - ${log.id}`}>
      <TableCell>{formattedDate}</TableCell>
      <TableCell>{log.contact}</TableCell>
      <TableCell>{log.status}</TableCell>
      <TableCell>{log.error}</TableCell>
    </TableRow>
  );
}
